export const JWT_ALGORITHM = 'HS256';
export const ENLIGHTEN_SUPPORT_URL =
  'https://enphase.com/en-us/support/solar-professionals/software?modal-content=support-regions?m=mgr';
export const ENSTORE_URL = 'https://store.enphase.com/storefront/';
//Dummy commit to test the build 